export default __webpack_public_path__ + "static/media/Dive4.27d3eeea.png";